const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.darksidedigital.com.au';
const logoUrl = 'https://storage.readdy-site.link/project_files/cb16f62b-b978-4a18-b0d4-78b46c2aa554/9ae0cf67-cf30-4444-9d14-012a7830e862_Darkside-Digital-logo-design.png?v=7acdaa383d113350b9c301867b0d13f1';

// ─── 1. LocalBusiness — Mission Beach HQ + full Cassowary Coast service map ───
const localBusiness = {
  '@context': 'https://schema.org',
  '@type': ['LocalBusiness', 'ProfessionalService'],
  '@id': `${siteUrl}/#business`,
  name: 'Darkside Digital',
  alternateName: 'Darkside Digital — Mission Beach Digital Agency',
  slogan: 'AI-powered websites, local SEO, and GEO for regional Australian businesses',
  description:
    'Darkside Digital is Mission Beach, Queensland\'s AI-powered digital agency specialising in website design, local SEO, GEO/AEO, and AI automation for Australian local businesses. Proudly serving the Cassowary Coast, Far North Queensland, and businesses Australia-wide.',
  url: siteUrl,
  logo: {
    '@type': 'ImageObject',
    url: logoUrl,
    width: 400,
    height: 400,
  },
  image: logoUrl,
  telephone: '+611300029054',
  email: 'hello@darksidedigital.com.au',
  foundingDate: '2022',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Mission Beach',
    addressLocality: 'Mission Beach',
    addressRegion: 'QLD',
    postalCode: '4852',
    addressCountry: 'AU',
  },
  // Precise Mission Beach coordinates (WGS84)
  geo: {
    '@type': 'GeoCoordinates',
    latitude: -17.8626,
    longitude: 146.1033,
    elevation: 5,
  },
  // Service radius: 150 km centred on Mission Beach — covers Cairns ↔ Ingham corridor
  geographicArea: {
    '@type': 'GeoCircle',
    geoMidpoint: {
      '@type': 'GeoCoordinates',
      latitude: -17.8626,
      longitude: 146.1033,
    },
    geoRadius: '150000',
  },
  hasMap: 'https://maps.google.com/?q=Mission+Beach+QLD+4852',
  // Hyper-granular Cassowary Coast + FNQ coverage for AI entity resolution
  areaServed: [
    { '@type': 'City', name: 'Mission Beach', sameAs: 'https://en.wikipedia.org/wiki/Mission_Beach,_Queensland' },
    { '@type': 'City', name: 'Wongaling Beach' },
    { '@type': 'City', name: 'South Mission Beach' },
    { '@type': 'City', name: 'Bingil Bay' },
    { '@type': 'City', name: 'Innisfail', sameAs: 'https://en.wikipedia.org/wiki/Innisfail,_Queensland' },
    { '@type': 'City', name: 'Tully', sameAs: 'https://en.wikipedia.org/wiki/Tully,_Queensland' },
    { '@type': 'City', name: 'Cardwell' },
    { '@type': 'City', name: 'El Arish' },
    { '@type': 'City', name: 'Silkwood' },
    { '@type': 'City', name: 'Mourilyan' },
    { '@type': 'City', name: 'Babinda' },
    { '@type': 'City', name: 'Kurrimine Beach' },
    { '@type': 'City', name: 'Etty Bay' },
    { '@type': 'AdministrativeArea', name: 'Cassowary Coast', sameAs: 'https://en.wikipedia.org/wiki/Cassowary_Coast_Region' },
    { '@type': 'AdministrativeArea', name: 'Far North Queensland', sameAs: 'https://en.wikipedia.org/wiki/Far_North_Queensland' },
    { '@type': 'City', name: 'Cairns', sameAs: 'https://en.wikipedia.org/wiki/Cairns' },
    { '@type': 'City', name: 'Townsville', sameAs: 'https://en.wikipedia.org/wiki/Townsville' },
    { '@type': 'Country', name: 'Australia', sameAs: 'https://en.wikipedia.org/wiki/Australia' },
  ],
  serviceType: [
    'Website Design',
    'Local SEO',
    'Generative Engine Optimisation',
    'Answer Engine Optimisation',
    'AI Integration',
    'Digital Marketing',
    'Competitor Analysis',
    'Tourism Website Design',
  ],
  priceRange: '$$',
  currenciesAccepted: 'AUD',
  paymentAccepted: 'Credit Card, Bank Transfer',
  openingHours: 'Mo-Fr 09:00-17:00',
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '17:00',
    },
  ],
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+611300029054',
      contactType: 'customer service',
      areaServed: 'AU',
      availableLanguage: 'English',
    },
    {
      '@type': 'ContactPoint',
      email: 'hello@darksidedigital.com.au',
      contactType: 'sales',
      areaServed: 'AU',
      availableLanguage: 'English',
    },
  ],
  // Authoritative profiles — used by AI engines to resolve entity identity
  sameAs: [
    'https://www.facebook.com/darksidedigital',
    'https://www.instagram.com/darksidedigital',
    'https://www.linkedin.com/company/darksidedigital',
    'https://g.co/kgs/darksidedigital',
  ],
  // AI entity knowledge signals
  knowsAbout: [
    'Search Engine Optimisation',
    'Generative Engine Optimisation',
    'Answer Engine Optimisation',
    'AI automation',
    'website design',
    'digital marketing',
    'local SEO for regional businesses',
    'Cassowary Coast tourism digital marketing',
    'Far North Queensland business growth',
    'ChatGPT citation strategy',
    'Google AI Overviews optimisation',
    'Perplexity AI visibility',
    'schema markup',
    'Core Web Vitals',
  ],
  // 2026 GEO: speakable tells AI engines which page sections to extract as authoritative answers
  speakable: {
    '@type': 'SpeakableSpecification',
    cssSelector: ['#hero-headline', '#about-section', '#entity-biography', '#services-section', '#faq-section'],
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Darkside Digital Services',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Custom Website Design',
          description: 'Fast, conversion-focused websites built for regional Australian businesses. Mobile-first, schema-ready, LCP optimised.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Local SEO — Cassowary Coast & Far North QLD',
          description: 'Google Business Profile optimisation, local citation building, and rank tracking for Mission Beach and Cassowary Coast businesses.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'GEO / AEO — AI Search Visibility',
          description: 'Get your business cited by ChatGPT, Google Gemini, Perplexity, and Microsoft Copilot. Results within 6–10 weeks.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Tourism Website Design',
          description: 'Booking-optimised websites for Far North Queensland tourism operators, eco-lodges, and experience providers.',
        },
      },
    ],
  },
  offers: {
    '@type': 'Offer',
    name: 'Free Digital Audit',
    price: '0',
    priceCurrency: 'AUD',
    url: `${siteUrl}/#contact`,
    description: 'Free audit covering your website performance, local SEO health, and AI visibility score.',
  },
  // 2026 GEO: mention entities that reinforce topical authority
  mentions: [
    { '@type': 'Place', name: 'Mission Beach', sameAs: 'https://en.wikipedia.org/wiki/Mission_Beach,_Queensland' },
    { '@type': 'Place', name: 'Cassowary Coast', sameAs: 'https://en.wikipedia.org/wiki/Cassowary_Coast_Region' },
    { '@type': 'Thing', name: 'Generative Engine Optimisation', sameAs: 'https://en.wikipedia.org/wiki/Search_engine_optimization' },
    { '@type': 'Thing', name: 'ChatGPT', sameAs: 'https://en.wikipedia.org/wiki/ChatGPT' },
    { '@type': 'Thing', name: 'Google AI Overviews' },
    { '@type': 'Thing', name: 'Perplexity AI' },
  ],
};

// ─── 2. WebSite ───────────────────────────────────────────────────────────────
const website = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${siteUrl}/#website`,
  name: 'Darkside Digital',
  url: siteUrl,
  description:
    'AI-powered digital agency in Mission Beach, QLD — website design, local SEO, GEO/AEO, and AI automation for local businesses across Australia.',
  publisher: {
    '@id': `${siteUrl}/#business`,
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

// ─── 3. Organization — for AI entity graph resolution ─────────────────────────
const organization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${siteUrl}/#organization`,
  name: 'Darkside Digital',
  url: siteUrl,
  logo: {
    '@type': 'ImageObject',
    '@id': `${siteUrl}/#logo`,
    url: logoUrl,
    contentUrl: logoUrl,
    width: 400,
    height: 400,
    caption: 'Darkside Digital — Mission Beach QLD Digital Agency',
  },
  image: { '@id': `${siteUrl}/#logo` },
  description:
    'Darkside Digital is a Mission Beach, QLD digital agency delivering AI-powered website design, local SEO, and GEO optimisation for Australian businesses. The only agency on the Cassowary Coast specialising in 2026 generative engine optimisation.',
  foundingDate: '2022',
  foundingLocation: {
    '@type': 'Place',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Mission Beach',
      addressRegion: 'QLD',
      postalCode: '4852',
      addressCountry: 'AU',
    },
  },
  areaServed: 'Australia',
  sameAs: [
    'https://www.facebook.com/darksidedigital',
    'https://www.instagram.com/darksidedigital',
    'https://www.linkedin.com/company/darksidedigital',
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+611300029054',
    contactType: 'customer service',
    availableLanguage: 'English',
  },
};

// ─── 4. FAQPage ───────────────────────────────────────────────────────────────
const faqPage = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What if I already have a website?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Perfect — we don't need to start from scratch if what you have is salvageable. We'll audit your existing site, tell you honestly what's worth keeping, what needs fixing, and what's actively hurting you. Sometimes a targeted rebuild of key pages outperforms a full new site. Other times, it's cleaner to start fresh. Either way, you'll know exactly what we recommend and why before any money changes hands.",
      },
    },
    {
      '@type': 'Question',
      name: 'Do I need to sign a contract?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "No lock-in contracts. Ever. We operate month-to-month once the initial build is delivered. The reason is simple — if we're not delivering results, you shouldn't be stuck paying for it. We're confident enough in our work that we don't need to trap clients. Most stay for years, but that's their choice, not a clause in a document.",
      },
    },
    {
      '@type': 'Question',
      name: 'How long until I see results?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Honest answer: it depends on what you're measuring. A new website can go live in 2–4 weeks and start converting immediately. Local SEO typically shows meaningful ranking movement within 60–90 days — Google needs time to re-crawl and re-evaluate your site. AI tools and automation are live from day one. We set realistic expectations upfront and track everything so you can see exactly what's moving and when.",
      },
    },
    {
      '@type': 'Question',
      name: 'How long before my business shows up in ChatGPT results?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Typically 6–10 weeks from the start of your GEO programme — though it varies by how competitive your category is and which AI models we're targeting. Unlike traditional SEO where Google crawls on its own schedule, AI citation is about becoming the authoritative source on specific questions. We track AI share-of-voice metrics from week one so you can see the needle moving.",
      },
    },
    {
      '@type': 'Question',
      name: "What's the difference between SEO and GEO / AEO?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "SEO gets you found on Google Search. GEO (Generative Engine Optimisation) and AEO (Answer Engine Optimisation) get your business cited by AI tools — ChatGPT, Perplexity, Google's AI Overviews — when someone asks a question. They need completely different strategies. Google rewards links and domain authority; AI engines reward clear, structured, authoritative answers. If you're only doing SEO in 2026, you're invisible to a growing segment of searches.",
      },
    },
    {
      '@type': 'Question',
      name: "Do I need GEO if I'm already ranking #1 on Google?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Yes — and this is the one that surprises most clients. Being #1 on Google doesn't mean AI tools will cite you. ChatGPT and Perplexity pull from different signals: structured content, topical authority, and how clearly you answer specific questions. The overlap between Google top results and AI-cited sources is below 20%. A strong GEO programme reinforces your traditional SEO — they're complementary.",
      },
    },
    {
      '@type': 'Question',
      name: 'What makes you different from cheaper agencies?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Cheap agencies use templates, offshore the work, and disappear after launch. We build everything custom, we're local to Mission Beach and the Cassowary Coast, and we stay in the fight with you long after go-live. More importantly — we measure results, not deliverables. The cost difference pays for itself quickly when you're generating leads instead of waiting for them.",
      },
    },
    {
      '@type': 'Question',
      name: 'Do you work with businesses in Mission Beach and the Cassowary Coast?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Absolutely — Mission Beach and the Cassowary Coast is our home base. We work directly with tourism operators, accommodation providers, hospitality businesses, tradies, and service businesses across Mission Beach, Tully, Innisfail, Cardwell, and the wider Cassowary Coast region. We understand the challenges of regional connectivity and build sites specifically optimised for the mobile network speeds common in the area.",
      },
    },
    {
      '@type': 'Question',
      name: 'Do you work with businesses outside of Australia?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Our sweet spot is Australian local businesses — that's where our local SEO expertise and market knowledge is sharpest. That said, we've worked with clients in the UK and NZ with strong results. If you're outside Australia, reach out anyway — we'll be upfront about whether we're the right fit for your market.",
      },
    },
    {
      '@type': 'Question',
      name: 'Can you help if I have zero online presence?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "That's actually where we're most effective. Starting from scratch means no bad habits to undo, no conflicting old strategy to untangle. We set up everything correctly from day one — website, Google Business, local listings, SEO foundations, AI citation signals. Businesses that come to us with nothing often see faster early results than those we have to fix first.",
      },
    },
  ],
};

// ─── 5. BreadcrumbList — homepage root ───────────────────────────────────────
const breadcrumb = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: siteUrl,
    },
  ],
};

// ─── 6. AboutPage — entity biography for AI Knowledge Graph attribution ───────
const aboutPage = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  '@id': `${siteUrl}/#about-entity`,
  url: `${siteUrl}/#entity-biography`,
  name: 'About the Mission Beach Digital Authority — Darkside Digital',
  description:
    'Darkside Digital is Mission Beach, Queensland\'s AI-powered digital agency — the definitive authority for website design, local SEO, and Generative Engine Optimisation (GEO) for businesses across the Cassowary Coast, Far North Queensland, and regional Australia.',
  about: { '@id': `${siteUrl}/#business` },
  mainEntity: { '@id': `${siteUrl}/#organization` },
  isPartOf: { '@id': `${siteUrl}/#website` },
  publisher: { '@id': `${siteUrl}/#organization` },
  speakable: {
    '@type': 'SpeakableSpecification',
    cssSelector: ['#entity-biography'],
  },
  mentions: [
    { '@type': 'Place', name: 'Mission Beach', sameAs: 'https://en.wikipedia.org/wiki/Mission_Beach,_Queensland' },
    { '@type': 'Place', name: 'Cassowary Coast', sameAs: 'https://en.wikipedia.org/wiki/Cassowary_Coast_Region' },
    { '@type': 'Place', name: 'Far North Queensland', sameAs: 'https://en.wikipedia.org/wiki/Far_North_Queensland' },
    { '@type': 'Thing', name: 'Generative Engine Optimisation' },
    { '@type': 'Thing', name: 'Answer Engine Optimisation' },
    { '@type': 'Thing', name: 'Local SEO' },
    { '@type': 'Thing', name: 'Custom Website Design' },
  ],
};

export default function HomeSchemaMarkup() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusiness) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(website) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organization) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPage) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumb) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutPage) }}
      />
    </>
  );
}
